import { ComponentInteractionType } from 'src/sdk-components/SceneComponent';

interface ISceneQuiz {
  default: any;
  fail?: any;
  success?: any;
}

interface SceneQuizData {
  visible: boolean;
  multipleAttempts: boolean;
  nodes: ISceneQuiz;
  polygons?: [];
  solutionIndex?: number;
}

export class SceneQuiz {
  visible: boolean;

  state: 'default' | 'fail' | 'success';

  nodes: ISceneQuiz;

  polygons: any = [];

  stateChangedCallback: any;

  constructor(data: SceneQuizData, stateChangedCallback: any) {
    this.stateChangedCallback = stateChangedCallback;

    this.nodes = data.nodes;
    this.setState('default');
    if (data.polygons) {
      this.polygons = data.polygons.map((polygon, index) => {
        return { isSolution: index === data.solutionIndex, component: polygon };
      });
      this.polygons.forEach((polygon) => {
        polygon.component.onEvent = (type) => {
          if (type === ComponentInteractionType.CLICK) {
            if (polygon.isSolution) {
              this.setState('success');
              this.setPolygonsVisible(false);
              setTimeout(() => {
                this.setVisible(false);
              }, 2000);
            } else {
              this.setState('fail');
              if (!data.multipleAttempts)
                setTimeout(() => {
                  this.setVisible(false);
                }, 2000);
            }
          }
        };
      });
    }
    // if (typeof data.visible === 'boolean')
    this.setVisible(data.visible);
  }

  setState(state: 'default' | 'fail' | 'success') {
    this.state = state;
    this.stateChangedCallback(state);
    Object.entries(this.nodes).forEach((obj) => {
      obj[1].node.root.visible = obj[0] === state;
    });
  }

  setVisible(visible) {
    this.visible = visible;
    Object.values(this.nodes).forEach((obj) => {
      obj.node.pivot.visible = visible;
    });
    this.setPolygonsVisible(visible);
  }

  setPolygonsVisible(visible) {
    this.polygons.forEach((polygon) => {
      polygon.component.root.visible = visible;
    });
  }

  resetAndShow() {
    this.setState('default');
    this.setVisible(true);
  }
}
